import { defineStore } from 'pinia'
import type { IMultiselectOption } from '~/types'

export const useDepositsFiltersStore = defineStore('deposits-filters', {
  state: () => ({
    searchQueryString: '',
    depositAmountRaw: undefined as number | undefined,
    currency: 'any',
    selectedPeriod: [] as IMultiselectOption[],
    selectedGuaranteeRequiredType: undefined as string | undefined,
    selectedTypes: [] as IMultiselectOption[],
    selectedPurpose: [] as IMultiselectOption[],
    selectedCreditType: [] as IMultiselectOption[],
    selectedOperations: [] as string[],
    selectedPercentPayments: [] as string[],
    currentPage: 1
  }),
  actions: {
    reset() {
      this.searchQueryString = ''
      this.depositAmountRaw = undefined
      this.currency = 'any'
      this.selectedPeriod = []
      this.selectedGuaranteeRequiredType = undefined
      this.selectedTypes = []
      this.selectedPurpose = []
      this.selectedCreditType = []
      this.selectedOperations = []
      this.selectedPercentPayments = []
      this.currentPage = 1
    }
  }
})
